import { AddCircleIcon } from '../assets/images';
import '../style/StickerCount.scss';

export interface StickerCountProps {
  count?: number;
  day?: number;
}

/**
 * returns JSX for sticker count
 */
export function StickerCount({ count, day }: StickerCountProps) {
  return (
    <div className="sticker-count">
      {day && day > 0 ? <AddCircleIcon /> : null}
      <div className="count fw-bold">{count?.toLocaleString()}</div>
    </div>
  );
}
